import Vue from 'vue'
import App from './App.vue'

//Importation des modules supplémentaire
import VueRouter from 'vue-router'
//Importation d'Axios
import axios from 'axios'

//Importation des routes
import {routes} from './routes';

Vue.use(VueRouter)

// As a plugin
import VueMask from 'v-mask'
Vue.use(VueMask);

const router= new VueRouter({
  routes,
  mode:'history',
  scrollBehavior(to, from, savedPosition){
    if(savedPosition){
      return savedPosition;
    }
    if(to.hash){
      return {selector:to.hash};
    }
  }
})

import {i18n} from './plugins/i18n'

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js